<form (submit)="false;"
      [attr.with-addons]="addons?.length > 0 ? '' : null"
      [id]="line.id"
      #form>
    <input type="text"
           name="groupLine"
           hidden
           [value]="line.sku">
    <input type="text"
           name="line"
           hidden
           [value]="line.id">
    <span [attr.mobile-title]="'BASKET.QUANTITY_LABEL' | translate"  class="actions">{{ line?.quantity  }}</span>
    <a class="media"
       [routerLink]="line?.productUrl">
        <img class="media"
             width="148"
             height="148"
             size="product-checkout"
             loading="eager"
             fetchPriority = "high"
             [use]="image"
             [alt]="line?.name"
             [srcset]="srcset" />
    </a>
    <a class="descriptor"
       [routerLink]="line?.productUrl">
        <span class="name">{{ line?.name }}</span>
        <span class="description">
            @for(variantOption of line.variantOptions; track variantOption.id){
                <span>{{ variantOption.title }} {{ variantOption.value }}</span>
            }
        </span>
    </a>
    <div class="indicators">
        @for(indicator of line?.indicators; track indicator.text) {
            <span class="indicator"
                  [style.color]="indicator?.textColor"
                  [style.backgroundColor]="indicator?.backgroundColor">{{ indicator.text }}</span>
        }
    </div>
    <span [attr.mobile-title]="'BASKET.UNIT_PRICE_LABEL' | translate" class="unit-price">{{ {amount: line?.unitPrice?.salesPrice?.amount - line?.unitPrice?.vatAmount?.amount, currency:line?.unitPrice?.salesPrice?.currency} | price }}</span>
    <span [attr.mobile-title]="'BASKET.DISCOUNT_PRICE_LABEL' | translate" class="discount-price">{{ line?.totalPrice?.listPrice?.amount - line?.totalPrice?.salesPrice?.amount > 0 ? ({amount:line?.totalPrice?.listPrice?.amount - line?.totalPrice?.salesPrice?.amount, currency:line?.totalPrice?.salesPrice?.currency} | price) : '' }}</span>
    <span [attr.mobile-title]="'BASKET.TOTAL_PRICE_LABEL' | translate" class="total-price">{{ {amount: line?.totalPrice?.salesPrice?.amount - line?.totalPrice?.vatAmount?.amount, currency:line?.totalPrice?.salesPrice?.currency} | price }}</span>
    @if(addons?.length > 0) {
        <span class="addons">
            @for(addon of addons; track addon.id) {
                <app-basket-addon-line [line]="addon"></app-basket-addon-line>
            }
        </span>
    }
</form>

<!--
<span>{{ 'BASKET.PRODUCT_NAME_LABEL' | translate }}</span>
<span></span>
<span class="center">{{ 'BASKET.QUANTITY_LABEL' | translate }}</span>
<span class="center">{{ 'BASKET.UNIT_PRICE_LABEL' | translate }}</span>
<span class="center">{{ 'BASKET.DISCOUNT_PRICE_LABEL' | translate }}</span>
<span class="end">{{ 'BASKET.TOTAL_PRICE_LABEL' | translate }}</span> -->
